import { FC } from "react"
import { DiaryFiltersFormValues } from "shared/types";
import { DiaryFiltersItem, DiaryFiltersItemTitle } from "./styles";
import { SearchList } from "shared/ui/searchList";
import { dictionaryItem } from "features/diary/lib/useDiaryFilters";

type DiaryDictionariesFilterProps = {
  formValues: Partial<DiaryFiltersFormValues>;
  dictionaryItems: dictionaryItem[];
  isDrawer: boolean;
  hideHeader?: boolean;
  onDictionaryReset: () => void;
  onDictionaryItemClick: (id: string) => void;
}

export const DiaryDictionariesFilter: FC<DiaryDictionariesFilterProps> = ({
  formValues,
  dictionaryItems,
  isDrawer,
  hideHeader,
  onDictionaryReset,
  onDictionaryItemClick
}) => {
  return (
    <DiaryFiltersItem>
      {!hideHeader && 
      <DiaryFiltersItemTitle>
        <span>Состояние</span>
        {Boolean(formValues.dictionariesIds?.length) && 
          <button onClick={onDictionaryReset}>Сбросить</button>
        }
      </DiaryFiltersItemTitle>
      }
      <SearchList 
        items={dictionaryItems}
        isDrawer={isDrawer}
        onItemClick={onDictionaryItemClick}
      />
    </DiaryFiltersItem>
  )
}